export function initCopy(){
    // Получаем элементы
    const copyButton = document.querySelector<HTMLButtonElement>('.button-copy');
    const copyTextContainer = document.querySelector<HTMLElement>('.copy-text');

    if (copyButton && copyTextContainer) {
        copyButton.addEventListener('click', async () => {
            try {
                // Берём текст внутри контейнера
                const textToCopy = Array.from(copyTextContainer.querySelectorAll('div.size-20'))
                    .map(el => el.textContent?.trim())
                    .filter(Boolean)
                    .join('\n');

                // Копируем в буфер обмена
                await navigator.clipboard.writeText(textToCopy!);

                // Показываем уведомление
                showCopyNotification(copyButton, 'Скопировано!');
            } catch (err) {
                console.error('Ошибка копирования:', err);
            }
        });
    }

    /**
     * Функция для показа уведомления
     */
    function showCopyNotification(target: HTMLElement, message: string) {
        const notification = document.createElement('div');
        notification.textContent = message;
        notification.style.position = 'absolute';
        notification.style.background = '#333';
        notification.style.color = '#fff';
        notification.style.padding = '8px 12px';
        notification.style.borderRadius = '6px';
        notification.style.fontSize = '14px';
        notification.style.whiteSpace = 'nowrap';
        notification.style.zIndex = '9999';
        notification.style.opacity = '0';
        notification.style.transition = 'opacity 0.3s, transform 0.3s';

        document.body.appendChild(notification);

        // Позиционируем поверх кнопки
        const rect = target.getBoundingClientRect();
        notification.style.left = `${rect.left + rect.width / 2 - notification.offsetWidth / 2}px`;
        notification.style.top = `${rect.top - 40}px`;

        // Анимация появления
        requestAnimationFrame(() => {
            notification.style.opacity = '1';
            notification.style.transform = 'translateY(-5px)';
        });

        // Через 1.5 секунды скрываем
        setTimeout(() => {
            notification.style.opacity = '0';
            notification.style.transform = 'translateY(-15px)';
            setTimeout(() => {
                notification.remove();
            }, 300);
        }, 1500);
    }

}